import UserAccessManagementPanel from '@frontend/components/user-access/UserAccessManagementPanel';
import type { User } from '@frontend/types';

export interface EcosystemMembersPanelProps {
  expanded: boolean;
  onToggle: () => void;
  user: User | null;
  ecosystemId: string;
  ecosystemLabel?: string;
}

/** Members attach/detach + project roles for the selected ecosystem. */
export default function EcosystemMembersPanel({
  expanded,
  onToggle,
  user,
  ecosystemId,
  ecosystemLabel,
}: EcosystemMembersPanelProps) {
  return (
    <div className="ecosystem-card admin-widget-card">
      <button type="button" className="admin-widget-header" onClick={onToggle}>
        <div className="admin-widget-header-main">
          <h3 className="ecosystem-title">Members &amp; project access</h3>
        </div>
        <span className="admin-widget-toggle">{expanded ? '▾' : '▸'}</span>
      </button>
      {expanded ? (
        <div className="admin-widget-body">
          {ecosystemId ? (
            <UserAccessManagementPanel
              user={user}
              ecosystemId={ecosystemId}
              ecosystemLabel={ecosystemLabel}
              hideCreateUser
            />
          ) : (
            <p className="tree-dashboard-muted">Select an ecosystem above.</p>
          )}
        </div>
      ) : null}
    </div>
  );
}
